import { render, staticRenderFns } from "./SolicitudConductorHistoricoEstado.vue?vue&type=template&id=b36f6faa"
import script from "./SolicitudConductorHistoricoEstado.vue?vue&type=script&lang=js"
export * from "./SolicitudConductorHistoricoEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports